import { Dispatch, MutableRefObject, SetStateAction } from "react";
import { SubheaderActions } from "iuvity-ui-components/dist/subheaderactions";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { Tag } from "iuvity-ui-components/dist/tag";
import { PrivilegeValidatorComponent } from "../../components/shared/PrivilegeValidatorComponent";
import { Button } from "iuvity-ui-components/dist/button";
import { formatDateToLocale } from "../../helpers/formatDate";
import { exportAuditDetailPdf } from "../../services/audit/audit";

interface AuditoryDetailProps {
    data: any;
    setShowDetail: Dispatch<SetStateAction<boolean>>;
    t: Function;
    permissionsInfoByRole: {
        CREATE: boolean,
        READ: boolean,
        UPDATE: boolean,
        REMOVE: boolean,
    };
    language: string;
    toast: MutableRefObject<any>;
}

export const AuditoryDetail: React.FC<AuditoryDetailProps> = ({
    data,
    setShowDetail,
    t,
    permissionsInfoByRole,
    language,
    toast,
}) => {
    window.scrollTo(0,0);

    const onDownloadReport = async () => {
        try {
            const fileReport = await exportAuditDetailPdf(data?.eventId, language);
            let blob = new Blob([fileReport], { type: 'application/pdf' });
            let filename = `audit-report_${new Date().toISOString().substring(0, 10).replace(/-|:/g, "") +
                "-" + new Date().toLocaleTimeString("es-ES").replace(/-|:/g, "")}.pdf`;
            let downloadLink = document.createElement("a");
            downloadLink.download = filename;
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
            downloadLink.click();
        } catch (error: any) {
            toast.current.replace({
                severity: "error",
                summary: "",
                detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
                life: 3000,
            });
        };
    };

    return (
        <div className="section_detail_audit_report">
            <SubheaderActions
                className="px-0 mx-2 pt-3 wrapper-environment-button"
                style={{ paddingBottom: '1rem !important' }}
                actions={[
                {
                    id: "111",
                    icon: "iu iu-icon-download",
                    label: t("ConsoleTranslations.downloadLabel"),
                    onClick: onDownloadReport,
                },
                ]}
            />

            <BoxFull className=" mdt-c mt-0 p-3">
                <div className="flex flex-column align-items-center justify-content-center">
                    <div
                        className="dt-appr-c"
                        style={{
                            minWidth: '65%',
                        }}
                    >
                        <div
                            className="dt-ap-col"
                            style={{
                                minWidth: '50%',
                                paddingLeft: '64px'
                            }}
                        >
                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t(`ConsoleTranslations.tenantLabel`)}
                                </div>
                                <div className="item-value">{data?.tenant}</div>
                            </div>

                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t("ConsoleTranslations.applicationLabel")}
                                </div>
                                <div className="item-value">
                                    {data?.application}
                                </div>
                            </div>

                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t("ConsoleTranslations.fullnameLabel")}
                                </div>
                                <div className="item-value">
                                    {data?.userName}
                                </div>
                            </div>

                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t("ConsoleTranslations.usernameLabel")}
                                </div>
                                <div className="item-value">
                                    {data?.userEmail}
                                </div>
                            </div>

                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t("ConsoleTranslations.roleLabel")}
                                </div>
                                <div className="item-value">
                                    {data?.role}
                                </div>
                            </div>
                        </div>

                        <div
                            className="dt-ap-col"
                            style={{
                                minWidth: '50%',
                                paddingLeft: '64px'
                            }}
                        >
                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t("ConsoleTranslations.idLabel")}
                                </div>
                                <div className="item-value">{data?.userId}</div>
                            </div>

                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t(`ConsoleTranslations.functionalityLabel`)}
                                </div>
                                <div className="item-value">
                                    {data?.functionality}
                                </div>
                            </div>

                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t(`ConsoleTranslations.activityLabel`)}
                                </div>
                                <div className="item-value">
                                    {data?.activity}
                                </div>
                            </div>

                            <div className="dt-ap-item">
                                <div className="item-title">
                                    {t(`ConsoleTranslations.objectLabel`)}
                                </div>
                                <div
                                    className="item-value"
                                    style={{
                                        maxWidth: "350px",
                                        lineBreak: "anywhere",
                                    }}
                                >
                                    {data?.objectJson}
                                </div>
                            </div>

                            <div className="flex align-items-center justify-content-center">
                                <div className="inputlabel subtitle p-1">
                                    {t(`ConsoleTranslations.statusLabel`)}
                                </div>
                            </div>
                            <div className="flex align-items-center justify-content-center mb-3">
                                <Tag
                                    severity={(data?.status?.toUpperCase() === t('ConsoleTranslations.SUCCESSLabel').toUpperCase()) ? 'success' : 'danger'}
                                    className={`flow-badge mt-2`}
                                    value={data?.status}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </BoxFull>
            <BoxFull className="my-5">
                <div className="flex align-items-start justify-content-center">
                    <div className="inputlabel subtitle p-1">
                        {`${t(`ConsoleTranslations.dateAndTimeLabel`)}:`}
                    </div>
                    <div className="inputlabel label px-1">
                        {formatDateToLocale(data?.creationDate, language, true)}
                    </div>
                </div>
                <div className="flex align-items-start justify-content-center">
                    <div className="inputlabel subtitle p-1">
                        {`IP:`}
                    </div>
                    <div className="inputlabel label px-1">
                        {data?.userIp}
                    </div>
                </div>
            </BoxFull>
            <div
             className="flex justify-content-end mb-3"
             style={{
                maxWidth: "100%",
                marginRight: "128px",
                marginTop: "32px",
             }}
            >
                <PrivilegeValidatorComponent showButton={true} >
                    <Button
                        variant="p-button"
                        label={t("ConsoleTranslations.returnBtnLabel")}
                        onClick={()=>{
                            setShowDetail(false);
                        }}
                    />
                </PrivilegeValidatorComponent>
            </div>
        </div>
    )
}